module.exports = __webpack_public_path__ + "static/media/newRoboticsPortfolio.9b46d10f.webp";